import {React, useEffect} from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import trend_cardimage_1 from "../images/Insights/trend_cardimage_1.png"
import trend_cardimage_2 from "../images/Insights/trend_cardimage_2.png"
import trend_cardimage_3 from "../images/Insights/trend_cardimage_3.png"

function Trends () {

    useEffect(()=>{
        AOS.init({duration:1000});
    }, [])

    const trendCard =[
        {
            src:trend_cardimage_1,
            date:"July-2025",
            heading:"Neighbourhood",
            content:"Insights into the best places to live, work, and invest.",
        },
        {
            src:trend_cardimage_2,
            date:"Aug-2025",
            heading:"Coimbatore Development Map",
            content:"See where the city is growing and where the opportunities lie.",
        },
        {
            src:trend_cardimage_3,
            date:"Mar-2025",
            heading:"Fair Price Index",
            content:"Track property values and make informed buying decisions.",
        },
    ]

    return (
    <>
        {/* Trend */}
        <div className="max-w-7xl mx-auto my-14 md:my-24">
            {/* <h1 className="font-[lora] text-[#363537] text-[54px] font-medium text-center lg:text-left lg:text-[52px]" data-aos="fade-up">Trend Articles</h1> */}
            <h1 className="subheading" data-aos="fade-up">Trend Articles</h1>
            <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[23px]'/>

            <div className="max-w-[1267px] mx-auto flex flex-wrap font-alibaba justify-between gap-x-2 my-4 px-4 sm:px-0" data-aos="fade-up">
                {
                trendCard.map((items) => {
                    return(
                        <div className="w-[399px] h-fit mx-auto relative mt-14 text-center" data-aos="fade-up">
                                <img src={items.src} alt="cardimage"/>
                                <h2 className="max-w-[336px] mx-auto font-noto text-[28px] font-bold leading-[40px] mt-[35px]">{items.heading}</h2>
                                <p className="max-w-[336px] mx-auto text-font-grey text-[17px] leading-[21px] pt-[10px] md:pt-[20px]">{items.content}</p>
                                <p className="text-font-grey text-[12px] uppercase leading-[18.8px] py-[20px]">{items.date}</p>

                            {/* <div className="lg:absolute bottom-0">
                                <button className="bg-yellow text-[10.5px] uppercase tracking-[1px] mt-4 py-2 px-4 ">view more</button>
                            </div> */}
                        </div> 
                    );
                })}
            </div> 
        </div>

    </>
    );

}

export default Trends;